import React from "react";
import ProfileView from "../views/ProfileView";

function ProfilePresenter() {
  return <ProfileView/>
}

export default ProfilePresenter;
